import React from "react";
import { MessageCircle, User, Megaphone, Target, Bot, Phone, Settings, LogOut } from "lucide-react";
import { AIIcon } from "./iconesCanais";

// Mesma ordem da NovoChatSidebar real: Chat, Contatos, Campanhas, Prospecção,
// Agentes, Automações Bot, VoIP, Definições.
const ITENS = [
  { Icone: MessageCircle, ativo: true },
  { Icone: User },
  { Icone: Megaphone },
  { Icone: Target },
  { Icone: AIIcon },
  { Icone: Bot },
  { Icone: Phone },
  { Icone: Settings },
];

export default function MockupSidebar() {
  return (
    <aside
      className="relative flex flex-col items-center h-full shrink-0 py-5"
      style={{
        width: 100,
        background: "linear-gradient(180deg, #2565EB 0%, #22BF64 100%)",
        borderRight: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "4px 0 24px rgba(0,0,0,0.25)",
      }}
    >
      <div
        className="flex items-center justify-center w-16 h-16 rounded-2xl"
        style={{ background: "rgba(255,255,255,0.1)", backdropFilter: "blur(8px)" }}
      >
        <img src="/evolzap-icon.png" alt="" className="w-9 h-9 object-contain" draggable={false} />
      </div>

      <nav className="flex-1 flex flex-col items-center justify-center gap-3">
        {ITENS.map(({ Icone, ativo }, i) => (
          <div
            key={i}
            className="flex items-center justify-center w-10 h-10 rounded-[10px]"
            style={
              ativo
                ? {
                    border: "1px solid rgba(255,255,255,0.5)",
                    background: "rgba(255,255,255,0.08)",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    transform: "translateY(-4px) scale(1.05)",
                  }
                : undefined
            }
          >
            <Icone className="w-5 h-5 text-white" strokeWidth={ativo ? 2.5 : 2} />
          </div>
        ))}
      </nav>

      <div
        className="flex items-center justify-center w-12 h-12 rounded-[14px]"
        style={{ background: "rgba(255,255,255,0.1)" }}
      >
        <LogOut className="w-5 h-5" style={{ color: "#f87171" }} />
      </div>
    </aside>
  );
}
